/* tslint:disable */
/* eslint-disable */
/**
 * Roles API
 * API for managing user roles
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Switch du rôle actif (enforcé côté serveur : « un rôle à la fois »). Le rôle doit être assigné à l'utilisateur — comparaison insensible à la casse.
 * 
 * @export
 * @interface SwitchRoleCommand
 */
export interface SwitchRoleCommand {
    /**
     * Nom du rôle à activer (insensible à la casse)
     * @type {string}
     * @memberof SwitchRoleCommand
     */
    roleName: string;
}

/**
 * Check if a given object implements the SwitchRoleCommand interface.
 */
export function instanceOfSwitchRoleCommand(value: object): value is SwitchRoleCommand {
    if (!('roleName' in value) || value['roleName'] === undefined) return false;
    return true;
}

export function SwitchRoleCommandFromJSON(json: any): SwitchRoleCommand {
    return SwitchRoleCommandFromJSONTyped(json, false);
}

export function SwitchRoleCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): SwitchRoleCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'roleName': json['roleName'],
    };
}

export function SwitchRoleCommandToJSON(json: any): SwitchRoleCommand {
    return SwitchRoleCommandToJSONTyped(json, false);
}

export function SwitchRoleCommandToJSONTyped(value?: SwitchRoleCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'roleName': value['roleName'],
    };
}

